<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.integrations')" :title="$t('integration.listTitle')">
      <div class="list__buttons">
        <MainButton v-if="admin" @click.native="handleCreate()">Create</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.integration_name" placeholder="Name" />
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('client', [])"
              v-if="filterData.client.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.client.length > 0">
                  {{ filterData.client[0].name }}

                  <template v-if="filterData.client.length > 1">
                    +{{ filterData.client.length - 1 }}
                  </template>
                </template>
                <template v-else> Clients </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_client" placeholder="Search Client" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.client"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('client', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('client', item)"
                  v-for="item in getCheckList('clientList', 'search_client', 'name', 'client')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <MainSelect
            :id="'is_active'"
            :placeholder="$t('common.activity')"
            :option-list="activeList"
            :set-value="filterData"
            :value="filterData.is_active"
            :labelName="'name'"
          />
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('language_ids', [])"
              v-if="filterData.language_ids.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.language_ids.length > 0">
                  {{ filterData.language_ids[0].code }}

                  <template v-if="filterData.language_ids.length > 1">
                    +{{ filterData.language_ids.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_language" placeholder="Search Language" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.language_ids"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('language_ids', item)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('language_ids', lang)"
                  v-for="lang in getCheckList(
                    'languageArray',
                    'search_language',
                    'code',
                    'language_ids',
                  )"
                  :key="lang.id"
                  class="check-selector__list-item"
                >
                  {{ lang.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
        <div
          @click="favoriteSwitch"
          :class="['list__filter-favorite', filterData.is_favorite && 'active']"
        >
          Favorite
          <template>({{ getCountFavorite() }})</template>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25px"
            height="25px"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              class="inner"
              d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
              fill="none"
            />
            <path
              class="border"
              d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
              stroke="#000000"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <div class="list">
        <div>
          <div v-for="(group, index) in groups" :key="index" class="list__group-container">
            <div class="list__group-name">Language {{ group.language.name }}</div>
            <CustomTable
              v-if="group.items.length"
              :data="group.items"
              :deleted-keys="tableOptions.deletedKeys"
              :rename-columns="tableOptions.renameColumn"
              :custom-order="tableOptions.customOrder"
              :is-action-block-visible="tableOptions.isActionBlockVisible"
              :handle-delete="admin && handleDelete"
              :handleFilter="handleFilter"
              :handle-edit="admin ? handleEdit : af_manager && handleValidStatuses"
              :handle-copy="admin && handleDetail"
              :handleDisabledButton="admin && handleDisabledButton"
              :handleFavoriteButton="handleFavoriteButton"
              :direction="directionSort"
              :order="orderSort"
              :name="'integrations'"
            >
              <template v-slot:extra>
                <div v-if="group.metrics" class="custom-table__row row-total total">
                  <div class="custom-table__row-item"><b>Total</b></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.remaining }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.cap }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.capDuplicate }}
                  </div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.sent }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.success }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.successDuplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.nonUnique }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ group.metrics.error }}
                  </div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item"></div>
                </div>
              </template>
            </CustomTable>
          </div>

          <div v-if="false" class="pagination">
            <div class="list__per-page">
              <div
                v-for="(item, index) in perPageList"
                @click="changePerPage(item)"
                :key="index"
                :class="['list__per-page-item', item == perPage && 'active']"
              >
                {{ item }}
              </div>
            </div>
            <Pagination
              :maxPage="integrations.lastPage"
              :page="page"
              :urlList="'INTEGRATION_LIST'"
              :totalItem="integrations.total"
              :queryParams="getQueryParameters"
            />
          </div>
        </div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal v-if="switchModal" :on-close="handleDisabledButtonModalClose" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">Change integration activity?</div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleDisabledButtonModalClose">NO</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDisabledButton" :button-cancel="true">YES</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the Integrations - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="detailModal" :on-close="handleCloseDetailModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-column">
          <div class="list__confirm-title">Log List</div>
          <div v-if="log" class="list__confirm-log-container">
            <div v-for="(item, index) in log" :key="index" class="list__confirm-log">
              <div class="list__confirm-log-type">
                {{ item.logType }}
              </div>
              <div class="list__confirm-log-event">{{ item.logEvent }}</div>
              <div class="list__confirm-log-time">{{ formatDate(item.logCreatedAt) }}</div>
            </div>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="validStatusesModal" :on-close="handleCloseValidStatuses" :modal-center="true">
      <div class="list__confirm list__valid-statuses">
        <div class="list__confirm-title">
          {{ $t("integration.validStatusesFor", { name: validStatusesRow.name }) }}
        </div>
        <ValidStatusesField
          v-model="validStatusesValue"
          :integration-id="validStatusesRow.id"
          :input-id="'valid-status-input-list'"
        />
        <div v-if="validStatusesError" class="list__valid-statuses-error">
          {{ validStatusesError }}
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseValidStatuses">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="saveValidStatuses">SAVE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">
        Integrations {{ deleteRow.name }} successfully deleted.
      </div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import moment from "moment";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";
import ValidStatusesField from "~/components/molecules/ValidStatusesField.vue";

export default {
  name: "IntegrationsList",
  metaInfo: {
    title: "Integrations List",
  },
  data() {
    return {
      admin: false,
      team_lead: false,
      bayer: false,
      af_manager: false,
      groups: [],

      search_client: "",
      search_language: "",

      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",
      perPage: 20,
      perPageList: [20, 40, 60, 80, 100],

      detailModal: false,
      chosenLead: null,

      switchModal: false,
      rowId: null,

      // аффилейт-менеджер редактирует только валидные статусы своих интеграций
      validStatusesModal: false,
      validStatusesRow: null,
      validStatusesValue: [],
      validStatusesError: "",

      log: null,

      filterData: {
        integration_name: "",
        client: [],
        is_active: null,
        is_favorite: false,
        language_ids: [],
      },
      isFilter: false,
      clientList: [],
      activeList: [
        {
          name: this.$t("integration.active"),
          id: "1",
        },
        {
          name: this.$t("integration.inactive"),
          id: "0",
        },
      ],

      languageArray: [],

      tableOptions: {
        deletedKeys: ["is_active", "is_favorite"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
          {
            from: "client_id",
            to: "Client",
          },
          {
            from: "send_counter",
            to: "Sent",
          },
          {
            from: "send_capacity",
            to: "CAP",
          },
          {
            from: "cost_type",
            to: "CT",
          },
          {
            from: "integration_type",
            to: "IT",
          },
          {
            from: "send_capacity_duplicate",
            to: "CAP Dup",
          },
          {
            from: "send_success",
            to: "Success",
          },
          {
            from: "send_success_duplicate",
            to: "Success Dup",
          },
          {
            from: "send_duplicate",
            to: "Non-unique",
          },
          {
            from: "send_error",
            to: "Error",
          },
          {
            from: "created_at",
            to: "Created At",
          },
          {
            from: "languages",
            to: "Language",
          },
        ],
        customOrder: [
          "id",
          "name",
          "languages",
          "client_id",
          "remaining",
          "send_capacity",
          "send_capacity_duplicate",
          "cost_type",
          "integration_type",
          "send_counter",
          "send_success",
          "send_success_duplicate",
          "send_duplicate",
          "send_error",
          "created_at",
          "is_active",
          "is_favorite",
        ],
      },

      formDataToSend: {
        name: "",
        is_active: true,
        type_id: null,
        cost_type: null,
        integration_type: null,
        language_id: null,
        client: null,
        send_frequency: "* * * * *",
        send_capacity: "",
        country_ids: {},
        api_key: "",
        api_url: "",
        map_id: "",
        send_capacity_duplicate: "",
        lead_fresh_time: "",
        send_work_time: {
          all: [
            { HH: "09", mm: "00" },
            { HH: "18", mm: "00" },
          ],
          days: {
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: [],
            sun: [],
          },
        },
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
    MainSelect,
    ValidStatusesField,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);

    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      } else if (this.user.groups[0].id == 7) {
        this.af_manager = true;
      }
    }

    this.getClient();
    this.getData();
    this.setQueryParams();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "integrations", "integrationsList"]),
    page() {
      return +this.$route.params.page;
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    getCheckList(listKey, filterKey, nameKey, chooseItem) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      // список выбранных id
      const selectedIds = Array.isArray(this.filterData[chooseItem])
        ? this.filterData[chooseItem].map((item) => item?.id)
        : [];

      const filterStr =
        rawFilter == null || String(rawFilter).trim() === ""
          ? null
          : String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        // ❌ исключаем если id уже выбран
        if (selectedIds.includes(item?.id)) return false;

        // если фильтра нет — возвращаем всё кроме выбранных
        if (!filterStr) return true;

        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
    getData() {
      leadApi
        .getLanguageList()
        .then((res) => {
          this.languageArray = res.data.items;
          this.getList();
        })
        .catch((error) => {})
        .finally(() => {});
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList(loading = true) {
      let url = `?page=${+this.$route.params.page}&perPage=${
        this.perPage
      }&with[0]=client&with[1]=languages&is_total=1`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      if (this.isFilter) {
        if (this.filterData.integration_name.length) {
          url += `&integration_name=${this.filterData.integration_name}`;
        }

        if (this.filterData.is_active && this.filterData.is_active != "all") {
          url += `&is_active=${this.filterData.is_active.id == 1 ? 1 : 0}`;
        }

        if (this.filterData.language_ids.length > 0) {
          const ids = this.filterData.language_ids;
          ids.forEach((item, index) => {
            url += `&language_ids[${index}]=${item.id}`;
          });
        }

        if (this.filterData.client.length > 0) {
          const ids = this.filterData.client;
          ids.forEach((item, index) => {
            url += `&client_id[${index}]=${item.id}`;
          });
        }
      }

      const local = JSON.parse(localStorage.getItem("favorite_integration") || "[]");
      const switchFavorite = JSON.parse(
        localStorage.getItem("favorite_integration_switch") || "false",
      );

      this.filterData.is_favorite = switchFavorite;

      if (switchFavorite) {
        if (local.length > 0) {
          local.forEach((item, index) => {
            url += `&ids[${index}]=${item}`;
          });
        } else {
          return;
        }
      }

      if (loading) {
        this.$store.commit("lead/setLoading", true);
      }

      leadApi
        .getIntegrationListGroup(url)
        .then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});

          const integrations = res.data.groups;

          if (integrations.length) {
            integrations.forEach((group, index) => {
              if (integrations[index].items.length) {
                for (let i = 0; integrations[index].items.length > i; i++) {
                  integrations[index].items[i].created_at = moment(
                    integrations[index].items[i].createdAt,
                  ).format("DD.MM.YYYY HH:mm");
                  integrations[index].items[i].is_favorite =
                    local.indexOf(integrations[index].items[i].id) !== -1 ? 1 : 0;
                  integrations[index].items[i].client_id = integrations[index].items[i].client.name;
                  integrations[index].items[i].send_counter =
                    integrations[index].items[i].sendCounter;
                  integrations[index].items[i].send_capacity =
                    integrations[index].items[i].sendCapacity;
                  integrations[index].items[i].is_active = integrations[index].items[i].isActive;
                  integrations[index].items[i].send_success =
                    integrations[index].items[i].sendSuccess;
                  integrations[index].items[i].cost_type = integrations[index].items[i].costType;
                  integrations[index].items[i].integration_type =
                    integrations[index].items[i].integrationType;
                  integrations[index].items[i].send_duplicate =
                    integrations[index].items[i].sendDuplicate;
                  integrations[index].items[i].send_error = integrations[index].items[i].sendError;
                  integrations[index].items[i].send_capacity_duplicate =
                    integrations[index].items[i].sendCapacityDuplicate;
                  integrations[index].items[i].send_success_duplicate =
                    integrations[index].items[i].sendSuccessDuplicate;
                  integrations[index].items[i].remaining =
                    integrations[index].items[i].send_capacity -
                    integrations[index].items[i].send_success +
                    (integrations[index].items[i].send_capacity_duplicate -
                      integrations[index].items[i].send_success_duplicate);

                  if (integrations[index].items[i].languages.length > 0) {
                    const langObj = this.languageArray.find((item) => {
                      return item.id == integrations[index].items[i].languages[0].languageId;
                    });

                    integrations[index].items[i].languages = langObj ? langObj.code : null;
                  } else {
                    integrations[index].items[i].languages = "";
                  }
                }
              }
            });
          }

          this.groups = integrations;
        })
        .catch((error) => {
          console.log(error);
          const { data } = error.response;
          this.$store.commit("lead/setError", data);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    async getClient() {
      let url = "";
      await leadApi
        .getClientListAll(url)
        .then((res) => {
          this.clientList = res.data;
          console.log(this.clientList);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    filterList() {
      this.isFilter = true;
      this.handleSetQueryParams();
    },
    handleSetQueryParams() {
      const filter = {};
      if (this.filterData.integration_name.length > 0) {
        filter.integration_name = this.filterData.integration_name;
      }
      if (this.filterData.is_active != null) {
        filter.is_active = this.filterData.is_active.id;
        filter.is_active_name = this.filterData.is_active.name;
      }

      if (this.filterData.client.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.client.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.client = ids.join(",");
        filter.client_name = name.join(",");
      }

      if (this.filterData.language_ids.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.language_ids.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.code);
        });

        filter.language_ids = ids.join(",");
        filter.language_ids_name = name.join(",");
      }

      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
        });
      }
      this.$router.push({ name: "IntegrationList", query: filter });
    },
    setQueryParams() {
      if (this.handleGetQueryParam("integration_name")) {
        this.filterData.integration_name = this.handleGetQueryParam("integration_name");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("is_active")) {
        this.filterData.is_active = {
          id: this.handleGetQueryParam("is_active"),
          name: this.handleGetQueryParam("is_active_name"),
        };
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("language_ids")) {
        const ids = this.handleGetQueryParam("language_ids").split(",");
        const names = this.handleGetQueryParam("language_ids_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.language_ids.push({
            id: ids[index],
            code: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("client")) {
        const ids = this.handleGetQueryParam("client").split(",");
        const names = this.handleGetQueryParam("client_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.client.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      setInterval(() => {
        this.getList(false);
      }, 60000);
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.$router.push({ name: "IntegrationList", query: {} });
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
        });
      }
      this.filterData.integration_name = "";
      this.filterData.client = [];
      this.filterData.is_active = null;
      this.filterData.language_ids = [];
      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleCreate() {
      this.$router.push({
        path: ROUTE.INTEGRATION_CREATE,
      });
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.INTEGRATION_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleValidStatuses(row) {
      this.validStatusesRow = row;
      this.validStatusesValue = Array.isArray(row.validStatuses) ? [...row.validStatuses] : [];
      this.validStatusesError = "";
      this.validStatusesModal = true;
    },
    handleCloseValidStatuses() {
      this.validStatusesModal = false;
      this.validStatusesRow = null;
    },
    saveValidStatuses() {
      this.$store.commit("lead/setLoading", true);
      leadApi
        .updateIntegrationValidStatuses(this.validStatusesRow.id, this.validStatusesValue)
        .then((res) => {
          if (res.success) {
            this.handleCloseValidStatuses();
            this.getList(false);
          }
        })
        .catch((error) => {
          this.validStatusesError =
            error.response?.status === 403
              ? this.$t("integration.noAccess")
              : this.$t("integration.saveFailed");
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    handleDetail(row) {
      this.detailModal = true;

      const url = `?perPage=100&page=1&sortField=id&sortDest=desc&entity_id=${row.id}`;

      this.$store.commit("lead/setLoading", true);
      leadApi
        .getIntegrationLog(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.log = res.data.data;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    handleCloseDetailModal() {
      this.detailModal = false;
      this.log = null;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("lead/setLoading", true);
      leadApi
        .deleteIntegration(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
    handleDisabledButtonModal(id = null) {
      if (id) {
        this.switchModal = true;
        this.rowId = id;
      }
    },
    handleDisabledButtonModalClose() {
      this.switchModal = false;
      this.rowId = null;
    },
    handleDisabledButton(id = null) {
      if (id) {
        this.rowId = id;
        this.getItem(this.rowId);
      }
    },

    getItem(id) {
      const url = `/${id}?with[0]=countries&with[1]=client&with[2]=languages`;
      this.$store.commit("lead/setLoading", true);

      this.formDataToSend = {
        name: "",
        is_active: true,
        type_id: null,
        cost_type: null,
        integration_type: null,
        language_id: null,
        client: null,
        send_frequency: "* * * * *",
        send_capacity: "",
        country_ids: {},
        api_key: "",
        api_url: "",
        map_id: "",
        send_capacity_duplicate: "",
        lead_fresh_time: "",
        send_work_time: {
          all: [
            { HH: "09", mm: "00" },
            { HH: "18", mm: "00" },
          ],
          days: {
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: [],
            sun: [],
          },
        },
        campaign_include_rule: [],
        campaign_exclude_rule: [],
      };

      try {
        leadApi.getItemIntegration(url).then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});
          const data = res.data;
          this.formDataToSend.name = data.name;
          this.formDataToSend.is_active = data.isActive;
          this.formDataToSend.type_id = data.typeId;
          this.formDataToSend.cost_type = data.costType;
          this.formDataToSend.integration_type = data.integrationType;
          this.formDataToSend.send_frequency = data.sendFrequency;
          this.formDataToSend.send_capacity = data.sendCapacity;
          this.formDataToSend.api_key = data.apiKey;
          this.formDataToSend.api_url = data.apiUrl;
          this.formDataToSend.map_id = data.mapId;
          this.formDataToSend.send_capacity_duplicate = data.sendCapacityDuplicate;
          this.formDataToSend.lead_fresh_time = data.leadFreshTime;

          if (data.campaignIncludeRule && data.campaignIncludeRule.length) {
            this.formDataToSend.campaign_include_rule = data.campaignIncludeRule;
          } else {
            this.formDataToSend.campaign_include_rule = [];
          }

          if (data.campaignExcludeRule && data.campaignExcludeRule.length) {
            this.formDataToSend.campaign_exclude_rule = data.campaignExcludeRule;
          } else {
            this.formDataToSend.campaign_exclude_rule = [];
          }

          if (data.languages.length > 0) {
            this.formDataToSend.language_id = data.languages[0].languageId;
          }

          if (data.clientId) {
            this.formDataToSend.client = data.client;
          }

          if (data.sendWorkTime.all) {
            this.formDataToSend.send_work_time.all = data.sendWorkTime.all.split("-").map((t) => {
              const [HH, mm] = t.split(":");
              return { HH, mm };
            });
          } else if (data.sendWorkTime.days) {
            const days = Object.keys(data.sendWorkTime.days);

            for (let i = 0; days.length > i; i++) {
              this.formDataToSend.send_work_time.days[days[i]] = data.sendWorkTime.days[days[i]]
                .split("-")
                .map((t) => {
                  const [HH, mm] = t.split(":");
                  return { HH, mm };
                });
            }
          }

          const country = data.countries;
          if (country != undefined && country.length > 0) {
            for (let i = 0; country.length > i; i++) {
              this.$set(this.formDataToSend.country_ids, country[i].countryId, true);
            }
          }

          this.handleSubmit();
        });
      } catch (error) {
        this.$store.commit("lead/setLoading", false);
        console.log(error);
      }
    },

    handleSubmit() {
      const data = {
        name: this.formDataToSend.name,
        is_active: !this.formDataToSend.is_active,
        type_id: this.formDataToSend.type_id,
        cost_type: this.formDataToSend.cost_type,
        integration_type: this.formDataToSend.integration_type,
        send_frequency: this.formDataToSend.send_frequency,
        send_capacity: this.formDataToSend.send_capacity,
        api_url: this.formDataToSend.api_url,
        api_key: this.formDataToSend.api_key,
        map_id: this.formDataToSend.map_id,
        send_capacity_duplicate: this.formDataToSend.send_capacity_duplicate,
        lead_fresh_time: this.formDataToSend.lead_fresh_time,
        campaign_include_rule: this.formDataToSend.campaign_include_rule,
        campaign_exclude_rule: this.formDataToSend.campaign_exclude_rule,
      };

      if (this.formDataToSend.language_id) {
        data.language_ids = [this.formDataToSend.language_id];
      } else {
        data.language_ids = [];
      }

      if (this.formDataToSend.client) {
        data.client_id = this.formDataToSend.client.id;
      }

      const key = Object.keys(this.formDataToSend.send_work_time.days);
      data.send_work_time = {};

      if (this.formDataToSend.send_work_time.all.length > 0) {
        data.send_work_time.all = `${this.formDataToSend.send_work_time.all[0].HH}:${this.formDataToSend.send_work_time.all[0].mm}-${this.formDataToSend.send_work_time.all[1].HH}:${this.formDataToSend.send_work_time.all[1].mm}`;
      } else {
        data.send_work_time.days = {};

        for (let i = 0; key.length > i; i++) {
          if (this.formDataToSend.send_work_time.days[key[i]].length == 2) {
            data.send_work_time.days[key[i]] = `${
              this.formDataToSend.send_work_time.days[key[i]][0].HH
            }:${this.formDataToSend.send_work_time.days[key[i]][0].mm}-${
              this.formDataToSend.send_work_time.days[key[i]][1].HH
            }:${this.formDataToSend.send_work_time.days[key[i]][1].mm}`;
          }
        }
      }

      const country = Object.keys(this.formDataToSend.country_ids);
      if (country.length) {
        let countrySend = [];
        for (let i = 0; country.length > i; i++) {
          if (this.formDataToSend.country_ids[country[i]] == true) {
            countrySend.push(+country[i]);
          }
        }
        if (countrySend.length > 0) {
          data.country_ids = countrySend;
        }
      }

      console.log(data);

      const url = `/${this.rowId}`;

      leadApi
        .editIntegration(url, data)
        .then((res) => {
          if (res.success) {
            this.getList();
            this.handleDisabledButtonModalClose();
            this.$store.commit("lead/setLoading", false);
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          const { data } = error.response;
          console.log(data);
        });
    },
    changePerPage(data) {
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.INTEGRATION_LIST.replace(":page", 1) + this.getQueryParameters,
        });
      }
      this.perPage = data;
      this.getList();
    },
    handleFavoriteButton(id) {
      // достаём и парсим
      let local = JSON.parse(localStorage.getItem("favorite_integration") || "[]");

      const index = local.indexOf(id);
      if (index === -1) {
        local.push(id); // добавить
      } else {
        local.splice(index, 1); // удалить
      }

      // сохраняем обратно в localStorage
      localStorage.setItem("favorite_integration", JSON.stringify(local));
      this.getList();
    },
    favoriteSwitch() {
      this.filterData.is_favorite = !this.filterData.is_favorite;
      localStorage.setItem("favorite_integration_switch", this.filterData.is_favorite);
      console.log(localStorage.getItem("favorite_integration_switch"));
      this.getList();
    },
    getCountFavorite() {
      let local = JSON.parse(localStorage.getItem("favorite_integration") || "[]");
      return local.length;
    },
    addCheckElement(key, value) {
      const foundObj = this.filterData[key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.filterData[key].push(value);
      }
    },
    removeCheckElement(key, value) {
      this.filterData[key] = this.filterData[key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset) {
      console.log("hello");
      this.filterData[key] = reset;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 0.5fr 1fr 230px !important;
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__group-name {
    font-size: 20px;
    font-weight: 700;
    padding-top: 30px;
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }

  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__valid-statuses {
    width: 640px;
    max-width: 100%;
    text-align: left;
  }

  &__valid-statuses-error {
    padding-top: 8px;
    color: #d33;
    font-size: 13px;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }

  &__per-page {
    display: flex;
    padding-right: 50px;
  }

  &__per-page-item {
    padding: 7px;
    background: rgb(136, 136, 136);
    color: #fff;
    border-radius: 5px;
    margin-right: 5px;
    font-weight: 700;
    cursor: pointer;

    &.active {
      background: #3c2a1e;
    }
  }
}

.pagination {
  display: flex;
  align-items: center;
}

.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
</style>
